import { PaymentTypeEnum } from '@models/api';
import { KeyValueType } from '@models/common';
import { EIBicRoleModel, StateTypeEnum } from '@models/module/entityInstance';
import { Permission } from '@models/permission';
import { DmUrlActionEnum } from '@module-instance/dynamic-module/common/dm.model';

export type ModuleRevisionModel = {
  entityInstanceId: number;
  moduleDocumentNumber: string;
  moduleId: number;
  revision: number;
  sovEntityInstanceId?: number;
};

export type DocumentInfoModel = {
  approvalId: number;
  approveLabel: string;
  canApprove: boolean;
  canCancel: boolean;
  canComment: boolean;
  canChangeAssignment: boolean;
  canChangeNumber: boolean;
  canPrint: boolean;
  canUpdate: boolean;
  canUseAuto: boolean;
  canViewAccessLog: boolean;
  commentLabel: string;
  contractId: number;
  entityInstanceId: number;
  existingDraftMessage: string;
  fromCorrespondence: boolean;
  hasManualDocumentAssignment: boolean;
  hasManagerAssignment: boolean;
  hasWbs: boolean;
  hasPdfMarkups: boolean;
  iAmInitiator: boolean;
  initiator: string;
  initiatorAbbr: string;
  initiatorRole: string;
  isArchived: boolean;
  isClosed: boolean;
  isClosedState: boolean;
  isContractClosedOrArchived: boolean;
  isDraftState: boolean;
  isPastRevision: boolean;
  isRevision: boolean;
  isStartedByPreset: boolean;
  pdfMarkupName: string;
  permissions: Permission[];
  rejectLabel: string;
  revision: number;
  revisions: ModuleRevisionModel[];
  rootId: number;
  screenId: number;
  screenLabel?: string;
  state: string;
  stateColor: string;
  stateTextColor: string;
  stateType: StateTypeEnum;
  userIsInitiator: boolean;
  workflowId: number;
  workflowGroupId?: number;
  usesWbsSov: boolean;
  workflowGroupName?: string;
  documentNumberId?: number;
  documentNoMinor?: number;
  documentNumber?: string;
  ballInCourt: EIBicRoleModel[];
  contractName: string;
  contractNumber: string;
  moduleId?: number;
  moduleAbbr: string;
  moduleDescription: string;
  moduleDocumentNumber: string;
  originalModuleDocumentNumber?: string;
  moduleName: string;
  projectName: string;
  projectNumber: string;
  workflowGroup: string;
  moduleDescriptionField: string;
  canDelete: boolean;
  /** Payment types for the document. This is used to add cipo-number fields in the nested table. */
  paymentTypes?: KeyValueType<PaymentTypeEnum, string>[];
};

export type DocumentRelationsModel = {
  canOpen: boolean;
  fieldId: number;
  fieldName: string;
  // investigate this type, should be an enum
  fieldType: number;
  isPayment: boolean;
  records: number;
  relatedModuleId: number;
  relatedModuleName: string;
  relationId: number;
  isNested: boolean;
};

export type DocumentDetailsQueryParams = {
  contractId: number;
  moduleId: number;
  entityInstanceId: number;
  workflowId: number;
  screenId: number;
  paymentPeriodId?: number;
  sovEntityInstanceId?: number;
  moduleTypeId?: number;
  /** Activity instance ID for navigating to a specific activity */
  activityInstanceId?: number;
};

export type DocumentDetailsDialogData = DocumentDetailsQueryParams & {
  showSidebar?: boolean;
  templateId?: number;
  urlActionId?: DmUrlActionEnum;
};
